import React from "react";
import {connect} from "react-redux";
import ChangeUsernameFormComponent from "../components/form/changeUsernameFormComponent";

function ProfilePage(props) {

    return (
        <div style={{minHeight: '100vh', backgroundColor: '#f5f5f5', paddingTop: '60px', paddingBottom: '40px', paddingLeft: '15px', paddingRight: '15px'}}>
            <div style={{maxWidth: '500px', margin: '0 auto'}}>
                <h1 style={{margin: '0 0 30px 0', color: '#333', fontSize: 'clamp(24px, 5vw, 28px)', textAlign: 'center'}}>
                    Profilim
                </h1>
                {
                    props.user &&
                    <div>
                        <ChangeUsernameFormComponent />

                        <div style={{marginBottom: '15px', padding: '12px', backgroundColor: '#f9f9f9', borderRadius: '8px', border: '1px solid #e0e0e0'}}>
                            <p style={{margin: '5px 0', fontSize: 'clamp(13px, 3.5vw, 14px)', color: '#666'}}>
                                <strong style={{color: '#333'}}>E-mail:</strong> {props.user.email}
                            </p>
                        </div>

                        {
                            props.user.phone_number &&
                            <div style={{marginBottom: '15px', padding: '12px', backgroundColor: '#f9f9f9', borderRadius: '8px', border: '1px solid #e0e0e0'}}>
                                <p style={{margin: '5px 0', fontSize: 'clamp(13px, 3.5vw, 14px)', color: '#666'}}>
                                    <strong style={{color: '#333'}}>Tel No:</strong> {props.user.phone_number}
                                </p>
                            </div>
                        }


                    </div>
                }
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.userReducer.user
})

export default connect(mapStateToProps) (ProfilePage);